export default __webpack_public_path__ + "static/logo-1d221de6302f9b2f1885c86fa66c17f1.png";